/* Oak & Hour theme search: the mockup's overlay on Shopify predictive
   search, with the shopper-language synonym map applied to the query. */

(function () {
  const SYN = {
    couch: "sofa", settee: "sofa", loveseat: "sofa",
    carpet: "rug", carpets: "rugs",
    comforter: "duvet",
    lamp: "lamp", lantern: "lamp",
    drawers: "dresser", chest: "dresser",
    bookcase: "bookshelf", shelves: "shelving",
    pillow: "cushion", pillows: "cushions",
    blanket: "throw", blankets: "throws",
    bedside: "nightstand", closet: "wardrobe", armoire: "wardrobe"
  };
  const expand = q => q.toLowerCase().split(/\s+/).map(w => SYN[w] || w).join(" ");

  let overlay, input, resultsEl, activeIndex = -1, debounceTimer;

  const recent = {
    list: () => OH.store.get("recent-searches", []),
    push(q) {
      if (!q) return;
      let l = recent.list().filter(x => x !== q);
      l.unshift(q);
      OH.store.set("recent-searches", l.slice(0, 6));
    }
  };

  function rowHTML(p, i) {
    const img = p.image ? `<img src="${p.image}" alt="" loading="lazy">` : "";
    return `<a class="search-row${i === activeIndex ? " active" : ""}" id="oh-opt-${i}" role="option" style="--i:${i}" href="${p.url}">
      <span class="search-thumb">${img}</span>
      <span class="search-row-main">
        <span class="search-row-name">${OH.esc(p.title)}</span>
        <span class="search-row-cat">${OH.esc(p.type || "")}</span>
      </span>
      <span class="search-row-price">${p.price ? OH.priceHTML(p.price, p.compareAt) : ""}</span>
    </a>`;
  }

  function renderIdle() {
    const r = recent.list();
    resultsEl.innerHTML = `
      ${r.length ? `<div class="search-section-label">Recent</div>` +
        r.map(q => `<button class="search-recent" data-requery="${OH.esc(q)}">${OH.esc(q)}</button>`).join("") : ""}
      <div class="search-section-label">People look for</div>
      ${["sofa", "oak dining table", "wool rug", "floor lamp", "duvet"].map(q =>
        `<button class="search-recent" data-requery="${q}">${q}</button>`).join("")}`;
  }

  async function renderResults() {
    const q = input.value.trim();
    if (!q) { activeIndex = -1; renderIdle(); return; }
    const url = OH.CONFIG.routes.predictiveSearch +
      "?q=" + encodeURIComponent(expand(q)) +
      "&resources[type]=product&resources[limit]=8&section_id=predictive-search";
    let hits = [];
    try {
      const res = await fetch(OH.CONFIG.routes.predictiveSearch + ".json?q=" + encodeURIComponent(expand(q)) + "&resources[type]=product&resources[limit]=8");
      const json = await res.json();
      hits = (json.resources && json.resources.results && json.resources.results.products) || [];
    } catch (e) { hits = []; }
    const live = OH.qs("[data-search-live]");
    if (live) live.textContent = hits.length + (hits.length === 1 ? " result" : " results");
    if (!hits.length) {
      resultsEl.innerHTML = `<div class="search-none">
        <p>Nothing in the house for "<b>${OH.esc(q)}</b>".</p>
        <a class="btn btn-ghost" href="/collections/bestsellers">Browse the house edit</a>
      </div>`;
      return;
    }
    resultsEl.innerHTML = hits.map((p, i) => rowHTML({
      title: p.title, url: p.url, type: p.type,
      image: p.featured_image && p.featured_image.url ? p.featured_image.url + "&width=100" : (p.image || ""),
      price: parseFloat(p.price) || 0,
      compareAt: parseFloat(p.compare_at_price) || 0
    }, i)).join("") +
      `<a class="search-all" href="${OH.CONFIG.routes.search}?q=${encodeURIComponent(expand(q))}">See all results for "${OH.esc(q)}" &rarr;</a>`;
  }

  function openSearch() {
    overlay.hidden = false;
    document.body.classList.add("oh-overlay-open");
    requestAnimationFrame(() => { overlay.classList.add("open"); input.focus(); });
    renderIdle();
    if (OH.track) OH.track("search_open");
  }
  function closeSearch() {
    overlay.classList.remove("open");
    document.body.classList.remove("oh-overlay-open");
    setTimeout(() => { overlay.hidden = true; }, 480);
    const btn = OH.qs("[data-open-search]");
    if (btn) btn.focus();
  }

  document.addEventListener("oh:shell", () => {
    overlay = OH.qs("[data-search-overlay]");
    input = OH.qs("[data-search-input]");
    resultsEl = OH.qs("[data-search-results]");
    if (!overlay) return;

    OH.qsa("[data-open-search]").forEach(b => b.addEventListener("click", openSearch));
    OH.qs("[data-close-search]").addEventListener("click", closeSearch);
    overlay.addEventListener("click", e => { if (e.target === overlay) closeSearch(); });
    document.addEventListener("oh:closeovers", closeSearch);

    input.addEventListener("input", () => {
      activeIndex = -1;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(renderResults, 180);
    });

    resultsEl.addEventListener("click", e => {
      const re = e.target.closest("[data-requery]");
      if (re) { input.value = re.getAttribute("data-requery"); renderResults(); input.focus(); }
      const row = e.target.closest(".search-row");
      if (row) {
        const q = input.value.trim();
        recent.push(q);
        if (OH.track) OH.track("search", { search_term: q, destination: row.getAttribute("href") });
      }
    });

    input.addEventListener("keydown", e => {
      const rows = OH.qsa(".search-row", resultsEl);
      if (e.key === "ArrowDown") { e.preventDefault(); activeIndex = Math.min(activeIndex + 1, rows.length - 1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); activeIndex = Math.max(activeIndex - 1, -1); }
      else if (e.key === "Enter") {
        const q = input.value.trim();
        if (q && OH.track) OH.track("search", { search_term: q, destination: activeIndex >= 0 && rows[activeIndex] ? rows[activeIndex].getAttribute("href") : OH.CONFIG.routes.search });
        if (activeIndex >= 0 && rows[activeIndex]) { recent.push(q); location.href = rows[activeIndex].getAttribute("href"); }
        else if (q) { recent.push(q); location.href = OH.CONFIG.routes.search + "?q=" + encodeURIComponent(expand(q)); }
        return;
      } else { return; }
      rows.forEach((r, i) => r.classList.toggle("active", i === activeIndex));
      input.setAttribute("aria-activedescendant", activeIndex >= 0 ? "oh-opt-" + activeIndex : "");
      if (activeIndex >= 0 && rows[activeIndex]) rows[activeIndex].scrollIntoView({ block: "nearest" });
    });

    document.addEventListener("keydown", e => {
      if (e.key === "/" && !e.target.closest("input, textarea, select")) { e.preventDefault(); openSearch(); }
    });
  });
})();
